import { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { AuthContext } from '@App/contexts/Auth';
import SignInView from '@src/ui/views/auth/SignInView';

import AuthLayout from '../layouts/AuthLayout';

const Login = () => {
    const { requestOTP, confirmOTP, isLoggedIn, loading } =
        useContext(AuthContext);

    const [waiting, setWaiting] = useState(true);
    const [confirmView, setConfirmView] = useState(false);

    const email = new URLSearchParams(useLocation().search).get('email') || '';
    const applicationId =
        new URLSearchParams(useLocation().search).get('applicationId') || '';

    const navigate = useNavigate();

    useEffect(() => {
        const checkLoginStatus = async () => {
            setWaiting(true);
            const loggedIn = await isLoggedIn();

            if (loggedIn) {
                navigate('/');
            } else {
                setWaiting(false);
            }
        };

        checkLoginStatus();
    }, [setWaiting, navigate, isLoggedIn]);

    return (
        <AuthLayout
            title='Log in'
            loading={waiting || loading}
            backButton={confirmView}
            setConfirmView={setConfirmView}
        >
            <SignInView
                requestOTP={requestOTP}
                confirmOTP={confirmOTP}
                email={email}
                applicationId={applicationId}
                confirmView={confirmView}
                setConfirmView={setConfirmView}
            />
        </AuthLayout>
    );
};

export default Login;
